export enum FeedbackType {
    None = 0,
    Tattle = 1,
    Akira = 2,
}